import { render, staticRenderFns } from "./KusClientAccessEmail.vue?vue&type=template&id=0624f4e4"
import script from "./KusClientAccessEmail.vue?vue&type=script&lang=js"
export * from "./KusClientAccessEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports